import {Integer} from 'platform/foundation';

import {CALL_PANEL_WIDTH} from '../constants/CALL_PANEL_WIDTH';
import {useCallPanel} from './useCallPanel';
import {useCallPanelContent} from './useCallPanelContent';

/**
 * For the layout: the width, in theme size steps, the docked call panel takes on the right of the
 * page under the top bar; `null` while it floats or is closed. Docking applies from notebook width
 * up; below that the panel always floats.
 */
export function useCallPanelDock(): {dockedWidth: Integer | null} {
  const {state: panel} = useCallPanel();
  const {isShown} = useCallPanelContent();

  return {dockedWidth: isShown && panel.mode === 'docked' ? CALL_PANEL_WIDTH : null};
}
